import React, {memo} from "react";
import {LabelColor} from "../../models/LabelColor";
import {Dialog} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {useTranslation} from "react-i18next";
import { 
    CloseButton, 
    DialogContainer, 
    ColorOptionRow, 
    ColorRadioInput, 
    ColorLabel, 
    NoneOptionRow, 
    NoneRadioInput 
} from './SelectLabelDialog.styles';

const SelectLabelDialog = (props: { onChange: (newColor: string | undefined) => void, onClose: () => void }) => {
    const {t} = useTranslation();
    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("nodeEditor.selectLabel")}</DialogTitle>
            <CloseButton onClick={props.onClose}>
                <CloseIcon/>
            </CloseButton>
            <DialogContent>
                <DialogContainer>
                    {Object.values(LabelColor).map((labelColor, index) =>
                        <ColorOptionRow key={index}>
                            <ColorRadioInput 
                                id={`colorPick_${index}`} 
                                type="radio" 
                                name="color" 
                                value={labelColor}
                                onChange={(ev) => props.onChange(labelColor)}
                            />
                            <ColorLabel 
                                htmlFor={`colorPick_${index}`} 
                                color={labelColor}
                            />
                        </ColorOptionRow>
                    )}

                    <NoneOptionRow>
                        <NoneRadioInput 
                            type="radio" 
                            name="color" 
                            value={undefined}
                            onChange={(ev) => props.onChange(undefined)}
                        />
                        <label>{t("nodeEditor.none")}</label>
                    </NoneOptionRow>
                </DialogContainer>
            </DialogContent>
        </Dialog>
    );
}

export default memo(SelectLabelDialog);